import { ServiceOffering } from "@idw-types/data/reference-data/generic";
import { FormattedServiceOfferingTotal, ServiceOfferingTotal } from "@idw-types/data/workflow-results-details";

export const formatServiceOfferingTotals = (
    serviceOfferingTotals: Array<ServiceOfferingTotal>,
    serviceOfferings: Array<ServiceOffering>
): Array<FormattedServiceOfferingTotal> => {
    return serviceOfferingTotals.map(sot => formatServiceOfferingTotal(sot, serviceOfferings));
};

export const formatServiceOfferingTotal = (
    serviceOfferingTotal: ServiceOfferingTotal,
    serviceOfferings: Array<ServiceOffering>
): FormattedServiceOfferingTotal => {
    const serviceOffering = serviceOfferings.find(so => +so.id === serviceOfferingTotal.serviceOfferingID);

    return {
        serviceOffering: serviceOffering,
        totalTransactionCount: serviceOfferingTotal.totalTransactionCount
    };
};